import { wasHelperInstalledOnThisDevice } from '@/config/helperPresence';
import { useHelperDialogStore } from '@/state/helperDialogStore';
import { useHelperStartDialogStore } from '@/state/helperStartDialogStore';

/** Show start-helper or download-helper dialog depending on prior use on this PC. */
export function showHelperOfflineDialog(): void {
  if (wasHelperInstalledOnThisDevice()) {
    useHelperStartDialogStore.getState().show();
    return;
  }
  useHelperDialogStore.getState().show();
}
